var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-normal inline-block py-2 px-4 rounded-full",class:[_vm.bgClass, {'text-base py-4 px-6 shadow': _vm.large}, {'text-sm ': !_vm.large}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }